import { ArrowBack } from '@mui/icons-material';
import { Grid, Typography, IconButton, Tabs, Tab, Card, CardMedia, CardContent } from '@mui/material';
import React, { useState, useEffect } from 'react';
import MainCard from 'ui-component/cards/MainCard';
import Services from 'utils/serviciosVentas';
import Actividad from '../ComponentsHomeVentas/Actividad';
import TemarioV2 from './TemarioV2';
import Ranking from 'views/Dash/Components/Ranking';
import Contacto from '../ComponentsHomeVentas/Contacto';
import ListaProcesos from '../ComponentsHomeVentas/ListaProcesos';
import moment from 'moment';

const VistaCurso = (props) => {
    const services = Services();
    const { usuario, cursoActual, regresaCurso, contacto, ranking, permisos } = props;
    const [datosCurso, setDatosCurso] = useState(null);
    const [openP, setOpenP] = useState(null);
    const [openS, setOpenS] = useState(null);
    const [openT, setOpenT] = useState(null);
    const [openA, setOpenA] = useState(null);
    const [infoActividad, setInfoActividad] = useState(null);
    const [select, setSelect] = useState('0');
    const validarDisponibilidadCurso = (curso) => {
        const ahora = moment();
        const fechaInicio = moment(curso.fechaInicioCurso);
        const fechaFin = moment(curso.fechaFinCurso);

        const estaDisponible = ahora.isSameOrAfter(fechaInicio) && ahora.isBefore(fechaFin);

        return estaDisponible;
    };

    const clickCambioTipo = (event, value) => {
        setSelect(value);
    };

    const cambiarOpenP = (id) => {
        setOpenP(id);
    };
    const cambiarOpenS = (id) => {
        setOpenS(id);
    };
    const cambiarOpenT = (id) => {
        setOpenT(id);
    };
    const cambiarOpenA = (id) => {
        setOpenA(id);
    };

    const asignaMaterialActivo = (detalle) => {
        cambiarOpenS(`sesion${detalle.idSesion}`);
        cambiarOpenT(`temario${detalle.idTemario}`);
        cambiarOpenA(`actividades${detalle.idActividad}`);
        onClickActividad(detalle);
    };

    const encontrarSiguienteDisponibleEnCurso = (datosCurso, idDetalleRecienCompletado) => {
        if (!datosCurso || !datosCurso.detalles || datosCurso.detalles.length === 0) {
            return null;
        }

        const detalles = datosCurso.detalles;
        const actividades = datosCurso.actividades || [];

        const cumpleDependenciasDetalle = (detalle, detallesDisponibles) => {
            if (!detalle.dependencia) {
                return true;
            }

            let dependencias = [];
            try {
                dependencias = JSON.parse(detalle.dependencia);
            } catch (e) {
                return true;
            }

            if (!Array.isArray(dependencias) || dependencias.length === 0) {
                return true;
            }

            const todasCompletadas = dependencias.every((dep) => {
                const detalleRequerido = detallesDisponibles.find((d) => d.idDetalleActividad == dep.idDetalleActividad);

                return detalleRequerido && detalleRequerido.idCalificacionDetalle && detalleRequerido.isAprobado == '1';
            });

            return todasCompletadas;
        };
        const detalleNecesitaCompletarse = (detalle) => {
            return !detalle.idCalificacionDetalle || detalle.isAprobado != '1';
        };

        const detallesOrdenados = [...detalles].sort((a, b) => {
            if (a.idSesion !== b.idSesion) {
                return Number(a.idSesion) - Number(b.idSesion);
            }
            if (a.idActividad !== b.idActividad) {
                return Number(a.idActividad) - Number(b.idActividad);
            }
            return Number(a.orden) - Number(b.orden);
        });

        const indiceRecienCompletado = detallesOrdenados.findIndex((d) => d.idDetalleActividad == idDetalleRecienCompletado);

        if (indiceRecienCompletado !== -1) {
            for (let i = indiceRecienCompletado + 1; i < detallesOrdenados.length; i++) {
                const detalleActual = detallesOrdenados[i];

                if (detalleActual.estatus != '1') continue;

                if (!sesionEstaDisponible(detalleActual.idSesion, datosCurso)) continue;

                if (detalleNecesitaCompletarse(detalleActual) && cumpleDependenciasDetalle(detalleActual, detallesOrdenados)) {
                    if (actividadCumpleDependencias(detalleActual.idActividad, actividades, datosCurso)) {
                        return detalleActual;
                    }
                }
            }
        }

        for (let i = 0; i < detallesOrdenados.length; i++) {
            const detalleActual = detallesOrdenados[i];

            if (detalleActual.estatus != '1') continue;

            if (!sesionEstaDisponible(detalleActual.idSesion, datosCurso)) continue;

            if (detalleNecesitaCompletarse(detalleActual) && cumpleDependenciasDetalle(detalleActual, detallesOrdenados)) {
                if (actividadCumpleDependencias(detalleActual.idActividad, actividades, datosCurso)) {
                    return detalleActual;
                }
            }
        }

        const completadas = detalles.filter((d) => d.idCalificacionDetalle && d.isAprobado == '1' && d.fechaCompletado);

        if (completadas.length > 0) {
            completadas.sort((a, b) => {
                const fechaA = new Date(a.fechaCompletado);
                const fechaB = new Date(b.fechaCompletado);
                return fechaB - fechaA;
            });

            return completadas[0];
        }

        return null;
    };

    const encontrarUltimaActividad = (datosCurso) => {
        if (!datosCurso || !datosCurso.detalles || datosCurso.detalles.length === 0) {
            return null;
        }

        const detalles = datosCurso.detalles;
        const actividades = datosCurso.actividades || [];

        const cumpleDependencias = (detalle, detallesDisponibles) => {
            if (!detalle.dependencia) {
                return true;
            }

            let dependencias = [];
            try {
                dependencias = JSON.parse(detalle.dependencia);
            } catch (e) {
                return true;
            }

            if (!Array.isArray(dependencias) || dependencias.length === 0) {
                return true;
            }

            const todasCompletadas = dependencias.every((dep) => {
                const detalleRequerido = detallesDisponibles.find((d) => d.idDetalleActividad == dep.idDetalleActividad);

                return detalleRequerido && detalleRequerido.idCalificacionDetalle && detalleRequerido.isAprobado == '1';
            });

            return todasCompletadas;
        };

        const detalleNecesitaCompletarse = (detalle) => {
            return !detalle.idCalificacionDetalle || detalle.isAprobado != '1';
        };

        const detallesOrdenados = [...detalles].sort((a, b) => {
            if (a.idSesion !== b.idSesion) {
                return Number(a.idSesion) - Number(b.idSesion);
            }
            if (a.idActividad !== b.idActividad) {
                return Number(a.idActividad) - Number(b.idActividad);
            }
            return Number(a.orden) - Number(b.orden);
        });

        const completadas = detalles.filter((d) => d.idCalificacionDetalle && d.fechaCompletado);

        if (completadas.length === 0) {
            return null;
        }

        // Buscar siguiente disponible despues de las completadas
        for (let i = 0; i < detallesOrdenados.length; i++) {
            const detalleActual = detallesOrdenados[i];

            if (detalleActual.estatus != '1') continue;

            if (!sesionEstaDisponible(detalleActual.idSesion, datosCurso)) continue;

            if (detalleNecesitaCompletarse(detalleActual) && cumpleDependencias(detalleActual, detallesOrdenados)) {
                if (actividadCumpleDependencias(detalleActual.idActividad, actividades, datosCurso)) {
                    return detalleActual;
                }
            }
        }

        const soloAprobadas = completadas.filter((d) => d.isAprobado == '1');

        if (soloAprobadas.length === 0) {
            return null;
        }

        soloAprobadas.sort((a, b) => {
            const fechaA = new Date(a.fechaCompletado);
            const fechaB = new Date(b.fechaCompletado);
            return fechaB - fechaA;
        });

        return soloAprobadas[0];
    };
    const sesionEstaDisponible = (idSesion, datosCurso) => {
        const sesiones = datosCurso?.sesiones || [];

        // Si no hay datos de sesiones asumir disponible  osea no bloquear
        if (sesiones.length === 0) return true;

        const sesion = sesiones.find((s) => String(s.idSesion) === String(idSesion));

        if (!sesion) return true;
        if (sesion.dependenciasCompletas === false) return false;

        if (!sesion.dependencia) return true;

        let deps = [];
        try {
            deps = JSON.parse(sesion.dependencia);
        } catch {
            return true;
        }
        if (!Array.isArray(deps) || deps.length === 0) return true;

        const sesionesAprobadas = sesiones
            .filter((s) => s.idCalificacionSesion != null && s.isAprobado == 1)
            .map((s) => String(s.idSesion));

        const depsActivas = deps.filter((dep) => {
            const padre = sesiones.find((s) => String(s.idSesion) === String(dep.idSesion));
            return padre && String(padre.estatus) === '1';
        });

        if (depsActivas.length === 0) return true;

        return depsActivas.every((dep) => sesionesAprobadas.includes(String(dep.idSesion)));
    };
    const actividadCumpleDependencias = (idActividad, actividades, cursoDatos) => {
        const datosAUsar = cursoDatos || datosCurso;

        const actividad = actividades.find((a) => a.idActividad == idActividad);
        if (!actividad) return false;
        if (!actividad.dependencia) return true;

        try {
            const dependencias = JSON.parse(actividad.dependencia);
            if (!Array.isArray(dependencias) || dependencias.length === 0) return true;

            const todasCompletadas = dependencias.every((dep) => {
                const idActividadPadre = dep.idActividad;

                //  buscar la actividad padre en actividades
                const actPadre = actividades.find((a) => a.idActividad == idActividadPadre);

                // Si el padre no existe bloquiar
                if (!actPadre || String(actPadre.estatus) !== '1') return true;

                const detallesActividadPadre = datosAUsar?.detalles?.filter((d) => d.idActividad == idActividadPadre) || [];

                if (detallesActividadPadre.length === 0) return false;

                const detallesActivos = detallesActividadPadre.filter((d) => d.estatus == '1');
                if (detallesActivos.length === 0) return false;

                return detallesActivos.every((d) => d.isAprobado == '1' && d.idCalificacionDetalle);
            });

            return todasCompletadas;
        } catch (e) {
            return true;
        }
    };

    const onClickFinalizarActividad = (det) => {
        services.enviaCalificacionDetalle(
            (res) => {
                const clone = JSON.parse(JSON.stringify(res));
                setDatosCurso(clone);

                const siguienteDisponible = encontrarSiguienteDisponibleEnCurso(clone, det.idDetalleActividad);

                if (siguienteDisponible) {
                    asignaMaterialActivo(siguienteDisponible);
                }
            },
            { ...det, idColaborador: usuario.idColaborador }
        );
    };

    const reiniciarExamen = (ex) => {
        services.reiniciarExamen(
            (res) => {
                const clone = JSON.parse(JSON.stringify(res));
                setDatosCurso(clone);

                const detalles = clone?.detalles;
                const actual = detalles.find((x) => x.idDetalleActividad == ex.idDetalleActividad);

                const actualParaMostrar = {
                    ...actual,
                    idCalificacionDetalle: null,
                    isAprobado: null,
                    calificacion: null,
                    aciertos: null,
                    desaciertos: null
                };

                asignaMaterialActivo(actualParaMostrar);
            },
            { ...ex, idColaborador: usuario.idColaborador }
        );
    };

    const onClickActividad = (det) => {
        const newDet = JSON.parse(JSON.stringify(det));
        services.getInfoActividad(
            (res) => {
                let objData = res?.data;
                setInfoActividad(null);
                setInfoActividad({ ...objData, ...newDet });
            },
            {
                idDetalleActividad: newDet.idDetalleActividad,
                tipo: newDet.idTipoActividad
            }
        );
    };

    //  useEffect para cargar y abrir automáticamente la última actividad
    // useEffect para cargar y abrir automáticamente la última actividad
    useEffect(() => {
        if (cursoActual) {
            services.buscaDatosCursoActual(
                (res) => {
                    setDatosCurso(res?.cursoActual);

                    // Buscar la última actividad completada
                    const ultimaActividad = encontrarUltimaActividad(res?.cursoActual);

                    // **SOLO abrir si hay una actividad**
                    // Si ultimaActividad es null = NO HAY AVANCE = Muestra portada
                    if (ultimaActividad) {
                        asignaMaterialActivo(ultimaActividad);
                    }
                    // Si es null, infoActividad permanece null y se muestra <PortadaCurso />
                },
                { idCurso: cursoActual.idCurso, idColaborador: usuario.idColaborador }
            );
        }
    }, [cursoActual]);

    // Componente para mostrar la portada del curso
    const PortadaCurso = () => {
        const srcPortada = cursoActual?.portadaCursoMostrar || 'https://cdn.pixabay.com/photo/2012/12/14/04/41/e-mail-69911_960_720.jpg';

        return (
            <Card
                sx={{
                    backgroundColor: '#ccbe95',
                    borderRadius: '10px',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center'
                }}
            >
                <CardMedia
                    component="img"
                    image={srcPortada}
                    alt={cursoActual?.titulo}
                    sx={{
                        maxHeight: '500px',
                        objectFit: 'contain',
                        padding: '20px'
                    }}
                />
                <CardContent sx={{ textAlign: 'center' }}>
                    <Typography variant="h3" sx={{ color: '#FFFFFF', mb: 2 }}>
                        {cursoActual?.titulo}
                    </Typography>
                    {cursoActual?.subtitulo && (
                        <Typography variant="h5" sx={{ color: '#FFFFFF', mb: 1 }}>
                            {cursoActual?.subtitulo}
                        </Typography>
                    )}
                    <Typography variant="body1" sx={{ color: '#FFFFFF', fontStyle: 'italic' }}>
                        Selecciona una actividad del temario para comenzar
                    </Typography>
                </CardContent>
            </Card>
        );
    };

    return (
        <MainCard
            title={
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Typography variant="title">{cursoActual?.titulo}</Typography>
                </div>
            }
        >
            <Grid container spacing={2}>
                <Grid item xs={12} md={8}>
                    {infoActividad != null ? (
                        <Actividad
                            permisos={permisos}
                            data={{ ...infoActividad, idColaborador: usuario.idColaborador, ncurso: cursoActual?.titulo }}
                            onClickFinalizar={onClickFinalizarActividad}
                            reiniciarExamen={reiniciarExamen}
                        />
                    ) : (
                        <PortadaCurso />
                    )}
                </Grid>
                <Grid item xs={12} md={4} direction="column">
                    <Tabs sx={{ p: 0 }} value={select} textColor="inherit" onChange={clickCambioTipo} aria-label="basic tabs example">
                        <Tab label="Temario" value="0" />
                        {Number(cursoActual.tipoCurso) == 2 && <Tab label="Procesos" value="3" />}
                        <Tab label="Contacto" value="2" />
                    </Tabs>
                    {select == '0' && (
                        <TemarioV2
                            curso={cursoActual}
                            temario={datosCurso}
                            onclick={onClickActividad}
                            openP={openP}
                            openS={openS}
                            openT={openT}
                            openA={openA}
                            cambiarOpenP={cambiarOpenP}
                            cambiarOpenS={cambiarOpenS}
                            cambiarOpenT={cambiarOpenT}
                            cambiarOpenA={cambiarOpenA}
                        />
                    )}
                    {select == '1' && <Ranking colaboradores={ranking?.topTen} />}
                    {select == '2' && <Contacto infoCotac={contacto} tipoCurso={cursoActual?.tipoCurso} />}
                    {select == '3' && <ListaProcesos usuario={usuario} />}
                </Grid>
            </Grid>
        </MainCard>
    );
};

export default VistaCurso;
